<div class="loader full-view loading"  [ngClass]="{loading: loaderService.loaderSubject$ | async}">
    <div></div>
</div>
